import { useContext, useEffect, useState, useCallback } from "react";
import { toast } from "react-hot-toast";
import { GlobalContext } from "../../../Context/GlobalContext";

/** tiny format helpers kept local */
const fmt = {
  dash: (v) => (v === null || v === undefined || v === "" ? "—" : v),
};

export default function useTransactions() {
  const { api, api2, baseUrl, adminId, latitude, longitude } =
    useContext(GlobalContext);

  const [clients, setClients] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState({});

  const setSpin = (id, action) => setBusy((p) => ({ ...p, [id]: action }));
  const clearSpin = (id) => setBusy((p) => ({ ...p, [id]: null }));


const getAllTransactionsReportV1 = async ({
  fromDate,
  toDate,
}) => {
  try {
    const res = await api.post(
      "/Transactions/getAllTransactionsReportV1",
      { fromDate, toDate }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage ||
          "Reports fetched",
        data: Array.isArray(res.data.response)
          ? res.data.response
          : [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "API error",
        data: [],
      };
    }
  } catch (e) {
    console.error(
      "getAllTransactionsReportV1 error:",
      e
    );
    return {
      success: false,
      message:
        "Failed to fetch transactions",
      data: [],
    };
  }
};

const refundProcessAdminApi = async (payload) => {
  try {
    const res = await api.post(
      "/Transactions/refundProccessAdmin",
      payload
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage ||
          "Refund processed",
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Refund failed",
      };
    }
  } catch (e) {
    console.error(
      "refundProccessAdmin error:",
      e
    );
    return {
      success: false,
      message: "Refund API failed",
    };
  }
};
const getAllPayoutList = async ({
  adminId,
  userid = "",
  fromDate,
  toDate,
}) => {
  try {
    const res = await api.post(
      "/Admin/getAllPayoutList",
      { adminId, userid, fromDate, toDate }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data:
          res.data.response?.report ||
          [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to fetch payouts",
        data: [],
      };
    }
  } catch (e) {
    console.error(
      "getAllPayoutList error:",
      e
    );
    return {
      success: false,
      message:
        "Error fetching payouts",
      data: [],
    };
  }
};
const getAdminTransactionsReport = async ({
  adnminId, // keep server spelling
  userid = "",
  fromDate,
  toDate,
  pageIndex,
  recordPerPage,
}) => {
  try {
    const res = await api.post(
      "/Admin/getTransactionsReport",
      {
        adnminId,
        userid,
        fromDate,
        toDate,
        pageIndex,
        recordPerPage,
      }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: Array.isArray(res.data.response)
          ? res.data.response
          : [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to fetch payments",
        data: [],
      };
    }
  } catch (e) {
    console.error(
      "getAdminTransactionsReport error:",
      e
    );
    return {
      success: false,
      message:
        "Error fetching payments",
      data: [],
    };
  }
};
const getSettlementConfig = async (userid) => {
  try {
    const res = await api.post(
      "/Order/v1.0/getSettlementConfig",
      { userid }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res.data.response || [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to load configuration",
        data: [],
      };
    }
  } catch (e) {
    console.error(
      "getSettlementConfig error:",
      e
    );
    return {
      success: false,
      message:
        "Error loading configuration",
      data: [],
    };
  }
};
const updateSettlementConfigurations = async ({
  userid,
  adminId,
  settlementCycle,
  settlementDay,
}) => {
  try {
    const res = await api.post(
      "/Admin/v1.0/updateSettlementConfigurations",
      {
        userid,
        adminId,
        settlementCycle,
        settlementDay,
      }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage ||
          "Updated",
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Update failed",
      };
    }
  } catch (e) {
    console.error(
      "updateSettlementConfigurations error:",
      e
    );
    return {
      success: false,
      message:
        "Error updating configuration",
    };
  }
};
const getRefundReportAdmin = async ({
  fromDate,
  toDate,
}) => {
  try {
    const res = await api.post(
      "/Transactions/getRefundReportAdmin",
      { fromDate, toDate }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage ||
          "Refund report loaded",
        data: Array.isArray(res.data.response)
          ? res.data.response
          : [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Refund report API error",
        data: [],
      };
    }
  } catch (e) {
    console.error(
      "getRefundReportAdmin error:",
      e
    );
    return {
      success: false,
      message:
        "Failed to fetch refund report",
      data: [],
    };
  }
};
const getUpiReportPaynnow = async ({
  userid,
  fromDate,
  toDate,
}) => {
  try {
    const res = await api.post(
      "/Transactions/v1.0/getUpiReportPaynnow",
      { userid, fromDate, toDate }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: Array.isArray(res.data.response)
          ? res.data.response
          : [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "API error",
        data: [],
      };
    }
  } catch (e) {
    console.error(
      "getUpiReportPaynnow error:",
      e
    );
    return {
      success: false,
      message:
        "Failed to fetch transactions",
      data: [],
    };
  }
};
const refundProcessV1 = async ({
  userid = "",
  amount,
  transactionId,
}) => {
  try {
    const res = await api.post(
      "/Transactions/v1.0/refundProccess",
      { userid, amount, transactionId }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage ||
          "Refund initiated",
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Refund failed",
      };
    }
  } catch (e) {
    console.error(
      "refundProccess error:",
      e
    );
    return {
      success: false,
      message:
        "Error processing refund",
    };
  }
};


  return {
    clients,
    orders,
    loading,
    busy,
    getAllTransactionsReportV1,
    refundProcessAdminApi,
    getAllPayoutList,
    getAdminTransactionsReport,
    getSettlementConfig,
updateSettlementConfigurations,
getRefundReportAdmin,
getUpiReportPaynnow,
refundProcessV1,




  };
}